import { ORG_UNITS_DEFAULT_FOR_DAY_SET } from '../../constants/types';
import { getDailyPlanningDetails } from './';

function setDefaultOrgUnit(orgUnitId) {
  return {
    type: ORG_UNITS_DEFAULT_FOR_DAY_SET,
    orgUnitId,
  };
}

function setDefaultOrgUnitForDay(orgUnitId) {
  return async dispatch => {
    await dispatch(setDefaultOrgUnit(orgUnitId));
    await dispatch(getDailyPlanningDetails());
  };
}

export { setDefaultOrgUnitForDay };
